import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { Textarea } from 'primeng/inputtextarea';
import { PanelModule } from 'primeng/panel';
import { DataViewModule } from 'primeng/dataview';

import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';

import { HisDynamicFieldComponent } from './component/field/his-dynamicfield.component';
import { FieldDirective } from './component/field/field.directive';
import { TextComponent } from './component/input-controls/text.component';
import { DateComponent } from './component/input-controls/date.component';
import { CheckboxComponent } from './component/input-controls/checkbox.component';
import { SelectComponent } from './component/input-controls/select.component';
import { RadioButtonComponent } from './component/input-controls/radiobutton.component';
import { PasswordComponent } from './component/input-controls/password.component';
import { TextAreaComponent } from './component/input-controls/text-area.component';
import { MultiSelectComponent } from './component/input-controls/multiselect.component';
import { InputNotImplementedComponent } from './component/input-controls/input-not-implemented.component';
import { LabelComponent } from './component/input-controls/label.component';
import { HisDynamicContainerComponent } from './component/input-controls/dynamic-container.component';
import { HisDynamicContainerInnerComponent } from './component/input-controls/dynamic-container-inner.component';
import { KeytableSelectComponent } from './component/input-controls/keytableselect.component';
import { KeytableMultiSelectComponent } from './component/input-controls/keytablemultiselect.component';
import { ChipsComponent } from './component/input-controls/chips.component';
import { FieldsetComponent } from './component/input-controls/fieldset.component';
import { YesNoSelectComponent } from './component/input-controls/yesnoselect.component';
import { YesNoWithTextAreaComponent } from './component/input-controls/yesno-with-textarea.component';
import { FloatnumberComponent } from './component/input-controls/floatnumber.component';
import { HisDynamicContentDirective } from './component/directive/his-dynamic-content.directive';
import { DynamicFormContainerComponent } from './component/form-container/dynamic-form-container.component';
import { ChipsModule } from 'primeng/chips';
import { OldNewFieldContainerComponent } from './component/field/old-new-field-container.component';

/**
 * SharedModule for common components.
 */
@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // primeNG
        AutoCompleteModule,
        CalendarModule,
        ConfirmDialogModule,
        DataViewModule,
        DialogModule,
        FileUploadModule,
        InputMaskModule,
        PanelModule,
        TableModule,
        ChipsModule,
        CalendarModule,
        InputTextModule,
        Textarea,

        // HIS
        HisCoreSharedModule,
        HisStructureSharedModule
    ],

    declarations: [
        CheckboxComponent,
        ChipsComponent,
        DateComponent,
        HisDynamicFieldComponent,
        FieldDirective,
        HisDynamicContainerComponent,
        HisDynamicContainerInnerComponent,
        HisDynamicContentDirective,
        InputNotImplementedComponent,
        LabelComponent,
        MultiSelectComponent,
        PasswordComponent,
        RadioButtonComponent,
        SelectComponent,
        TextAreaComponent,
        TextComponent,
        KeytableSelectComponent,
        KeytableMultiSelectComponent,
        YesNoSelectComponent,
        YesNoWithTextAreaComponent,
        FieldsetComponent,
        FloatnumberComponent,
        OldNewFieldContainerComponent,
        DynamicFormContainerComponent //
    ],

    exports: [
        HisDynamicFieldComponent,
        HisDynamicContainerComponent,
        HisDynamicContentDirective,
    ]
    // NO PROVIDERS! Providers need to go into CommonCoreModule
} )
export class HisDynamicFormSharedModule {
}
